import { DATE_RANGE_LIST, FilterDateRange } from "../interfaces/IDeductionFilter";

export const GetFilterDateRangeLabel = (value: FilterDateRange) => {
    if (!value) return null;
    return DATE_RANGE_LIST.find(item => item.value === value)?.label;
  };